import {
  FilterMode,
  SatelliteHeartbeat_OrderBy,
  SatelliteHeartbeat,
  SortOrder,
  SatelliteHeartbeat_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const satelliteHeartbeatService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.satelliteHeartbeatOne({ id });
    return result.satelliteHeartbeatOne as SatelliteHeartbeat;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SatelliteHeartbeat_OrderBy[] | null = null,
    filter: SatelliteHeartbeat_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SatelliteHeartbeat_Filter | undefined;
    if (searchValue !== "") {
      where = {
        publicIp: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.satelliteHeartbeatListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ publicIp: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.satelliteHeartbeatListWithOffset
    ) as SatelliteHeartbeat[];
    return { list, orderBy };
  },
};
